import axios from 'axios';

export const getMonthlySalesByRestaurant = async (
  supplierId,
  fromDate,
  toDate,
  token,
  limit = 10,
) => {
  const response = await axios.get(
    `${process.env.API_URL}/reports/suppliers/${supplierId}/monthly-sales?fromDate=${fromDate}&toDate=${toDate}&limit=${limit}`,
    {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
        'content-type': 'application/json',
      },
    },
  );
  return response.data;
};

export const getCurrentMonthSalesByRestaurant = async (supplierId, token, limit = 10) => {
  const response = await axios.get(
    `${process.env.API_URL}/reports/suppliers/${supplierId}/current-month-sales?limit=${limit}`,
    {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
        'content-type': 'application/json',
      },
    },
  );
  return response.data;
};

export const getCurrentMonthProductSales = async (supplierId, token, limit = 10) => {
  const response = await axios.get(
    `${process.env.API_URL}/reports/suppliers/${supplierId}/current-month-top-products?limit=${limit}`,
    {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
        'content-type': 'application/json',
      },
    },
  );
  return response.data;
};
